import axios from 'axios';
import { OptionType } from 'components';
import { Perimetre } from 'core/models';

export function getMenuPerimetre() {
    return axios.get<Perimetre[]>(`/menus/perimetre`, {
        params: {},
    });
}

export function getMenuCSP() {
    return axios
        .get(`/menus/csp`, {
            params: {},
        })
        .then((r: OptionType[]) => r);
}

export function getMenuSouscripteurs() {
    return axios
        .get(`/menus/souscripteurs`, {
            params: {},
        })
        .then((r: OptionType[]) => r);
}

export function getMenuSinisterNatures() {
    return axios
        .get(`/affilie/compensation/sinister_natures`, {
            params: {},
        })
        .then((r: OptionType[]) => r);
}

export function getMenuTypesContrat() {
    return axios
        .get(`/menus/types_contrat`, {
            params: {},
        })
        .then((r: OptionType[]) => r);
}

export function getMenuStatutsAdhesion() {
    return axios
        .get(`/menus/statuts_adhesion`, {
            params: {},
        })
        .then((r: OptionType[]) => r);
}
